import { Boxes, CalendarDays, CalendarRange, CheckCircle2, Clock, Play, UserX } from "lucide-react";
import { Skeleton } from "@bookdental/ui";

type Resumo = {
  consultasHoje: number;
  emAtendimento: number;
  concluidasHoje: number;
  consultasNoMes: number;
};

type ResumoLab = {
  emProducao: number;
  aguardandoConfirmacao: number;
  semResponsavel: number;
  recebidosNoMes: number;
};

/**
 * Mesma linguagem dos chips de Membros — quatro números, sem gráfico. O que muda é a FONTE, e ela
 * muda por tipo de organização: clínica lê a agenda, laboratório lê a produção. Laboratório não tem
 * consulta, então mostrar "Consultas hoje" ali seria número de outro negócio, sempre zero.
 */
export function OperacaoChips({
  resumo,
  resumoLab,
  carregando,
}: {
  resumo?: Resumo | null;
  resumoLab?: ResumoLab | null;
  carregando: boolean;
}) {
  const chips = resumoLab
    ? [
        { icon: Boxes, label: "Serviços em produção", value: resumoLab.emProducao, accent: "#f59e0b" },
        { icon: Clock, label: "Aguardando confirmação", value: resumoLab.aguardandoConfirmacao, accent: "#0ea5e9" },
        { icon: UserX, label: "Sem responsável", value: resumoLab.semResponsavel, accent: "#ef4444" },
        { icon: CalendarRange, label: "Recebidos no mês", value: resumoLab.recebidosNoMes, accent: "#2457ff" },
      ]
    : [
        { icon: CalendarDays, label: "Consultas hoje", value: resumo?.consultasHoje, accent: "#0ea5e9" },
        { icon: Play, label: "Em atendimento agora", value: resumo?.emAtendimento, accent: "#0891b2" },
        { icon: CheckCircle2, label: "Concluídas hoje", value: resumo?.concluidasHoje, accent: "#16a34a" },
        { icon: CalendarRange, label: "Consultas no mês", value: resumo?.consultasNoMes, accent: "#2457ff" },
      ];

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {chips.map(({ icon: Icon, label, value, accent }) => (
        <div
          key={label}
          className="flex items-center gap-2 rounded-lg border border-zinc-200 px-2.5 py-2 dark:border-border"
        >
          <span
            className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md"
            style={{ backgroundColor: `${accent}1a`, color: accent }}
          >
            <Icon className="h-3.5 w-3.5" />
          </span>
          <div className="min-w-0">
            {carregando ? (
              <Skeleton className="h-4 w-8" />
            ) : (
              <p className="text-sm font-semibold leading-tight tabular-nums text-zinc-900 dark:text-foreground">
                {value ?? 0}
              </p>
            )}
            <p className="text-[10.5px] leading-tight text-zinc-500 sm:truncate dark:text-muted-foreground">
              {label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
